var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"TermsAndConditions"}},[_c('terms-hero'),_vm._v(" "),_c('v-container',[_c('div',{staticClass:"page__",domProps:{"innerHTML":_vm._s(_vm.wpContent)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }